import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, shallowRef, watchEffect } from 'vue'
import { DataRow, Table } from '../../types/components/data-rendering'
import { useStoreProfiles } from '../../store/useStoreProfiles'
import { storeToRefs } from 'pinia'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkView',
  setup(__props) {

const loading = ref(true)
const data = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    const { getWorkView } = storeToRefs(useStoreProfiles())
    data.value = getWorkView.value
    loading.value = false
  },
  { flush: 'post' }
)
//settings for table
const displayOptions = computed(() => {
  return {
    route: { link: (row: DataRow) => `/stores/${row.store_id}` },
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FilteringDataDisplay, {
    key: `${loading.value}-workView`,
    "enable-filters": true,
    "is-loading": loading.value,
    "table-data": data.value,
    options: displayOptions.value
  }, null, 8, ["is-loading", "table-data", "options"]))
}
}

})